module.exports = __webpack_public_path__ + "static/media/woman-holding-pencil-herdy.0d790612.svg";